var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"overlay_message"},[_c('span',{staticClass:"overlay_message__loading"},[_c('loading-icon',{attrs:{"dark":true}})],1),_vm._v(" Загрузка... ")])}
var staticRenderFns = []

export { render, staticRenderFns }